export default {
  data() {
    return {}
  },
  methods: {
    checkIsOnlineOnetime(resolve) {
      const that = this
      if (window.navigator.onLine) {
        this.$store.commit('onlineStatus', 'online')
        this.$confirmOnly('提示', '网络已恢复正常！！', {
          showClose: false,
          showCancelButton: false,
          confirmTxt: '继续',
          closeOnClickModal: false
        }).then(() => {
          if (window.navigator.onLine) {
            resolve()
          } else {
            that.checkIsOnlineOnetime(resolve)
          }
        })
      } else {
        this.$store.commit('onlineStatus', 'offline')
        console.info(this.$confirmOnly)
        this.$confirmOnly('提示', '当前网络异常，请检查网络！', {
          showClose: false,
          confirmTxt: '重新检测',
          cancelTxt: '退出',
          closeOnClickModal: false
        })
          .then(() => {
            setTimeout(() => {
              that.checkIsOnlineOnetime(resolve)
            }, 1000)
          })
          .catch(() => {
            that.quit()
          })
      }
    },
    checkIsOnline() {
      return new Promise(resolve => {
        if (window.navigator.onLine) {
          resolve()
        } else {
          this.checkIsOnlineOnetime(resolve)
        }
      })
    },
    quit() {
      const fromUrl = this.$route.query.fromUrl
      if (fromUrl) {
        const _url = decodeURIComponent(fromUrl)
          .replace(/{{q}}/g, '?')
          .replace(/{{a}}/g, '&')
        const isCorrect = this.$route.query.isCorrect

        if (isCorrect) {
          this.$router.push({
            path: _url,
            query: { from: isCorrect }
          })
        } else {
          window.location.href = _url
        }
      } else {
        this.$router.push({ name: 'stuIndex' })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Stu/StuPractice/StuExam/mixins.js